/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Pharmacy Counselor API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";

export const PharmacyCounselorCounselingCountGroupedByPharmacyIDTimeTypename =
  "PharmacyCounselorCounselingCountGroupedByPharmacyIDTime" as const;

/**
 *
 * @export
 * @interface PharmacyCounselorCounselingCountGroupedByPharmacyIDTime
 */
export interface PharmacyCounselorCounselingCountGroupedByPharmacyIDTime {
  /**
   *
   * @type {number}
   * @memberof PharmacyCounselorCounselingCountGroupedByPharmacyIDTime
   */
  count?: number;
  /**
   *
   * @type {string}
   * @memberof PharmacyCounselorCounselingCountGroupedByPharmacyIDTime
   */
  time?: string;
  /**
   * Resource type name
   * @type {string}
   * @memberof PharmacyCounselorCounselingCountGroupedByPharmacyIDTime
   */
  readonly __typename?: string;
}

export function PharmacyCounselorCounselingCountGroupedByPharmacyIDTimeFromJSON(
  json: any
): PharmacyCounselorCounselingCountGroupedByPharmacyIDTime {
  return PharmacyCounselorCounselingCountGroupedByPharmacyIDTimeFromJSONTyped(json, false);
}

export function PharmacyCounselorCounselingCountGroupedByPharmacyIDTimeFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PharmacyCounselorCounselingCountGroupedByPharmacyIDTime {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PharmacyCounselorCounselingCountGroupedByPharmacyIDTimeTypename,

    count: !exists(json, "count") ? undefined : json["count"],
    time: !exists(json, "time") ? undefined : json["time"],
  };
}

export function PharmacyCounselorCounselingCountGroupedByPharmacyIDTimeToJSON(
  object?: PharmacyCounselorCounselingCountGroupedByPharmacyIDTime | null
): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    count: value.count,
    time: value.time,
  };
}
